package com.nonopn.skywatcher.common.api

import io.ktor.client.HttpClient

class ApiNoSession(
    private val baseUrl: String,
    private val client: HttpClient
) {
    private val calls = DoNetworkCalls(
        client
    )

    suspend fun login(body: LoginRequest): APIUserSession = calls.post(
        "$baseUrl/login",
        body
    )

    suspend fun register(body: LoginRequest): APIUserSession = calls.post(
        "$baseUrl/register",
        body
    )

    /** POST /api/checkout/login: exchanges the one time code of the checkout success URL for a token. */
    suspend fun checkoutLogin(body: CheckoutLoginRequest): CheckoutLoginAnswer = calls.post(
        "$baseUrl/api/checkout/login",
        body
    )
}
